import USFlag from "~/assets/images/flags/us.jpg";
import FrenchFlag from "~/assets/images/flags/french.jpg";
import SpainFlag from "~/assets/images/flags/spain.jpg";
import ChinaFlag from "~/assets/images/flags/china.png";
import ArabicFlag from "~/assets/images/flags/arabic.png";

export const LanguagesWithFlag = [
  {
    flag: USFlag,
    language: "en",
    title: "English"
  },
  {
    flag: FrenchFlag,
    language: "fr",
    title: "French"
  },
  {
    flag: SpainFlag,
    language: "es",
    title: "spanish"
  },
  {
    flag: ChinaFlag,
    language: "zh",
    title: "Chinese"
  },
  {
    flag: ArabicFlag,
    language: "ar",
    title: "Arabic"
  }
];
